import { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLanguage } from "@/contexts/LanguageContext";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { language } = useLanguage();

  return (
    <div className={`min-h-screen flex flex-col dark:bg-nexus-dark dark:text-white ${language === 'ar' ? 'text-right' : 'text-left'}`}>
      <a
        href="#main-content"
        className="fixed left-4 top-4 z-[100] -translate-y-24 rounded-md bg-nexus-brand px-4 py-2 font-medium text-white transition-transform focus:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-nexus-brand"
      >
        {language === "ar" ? "انتقل إلى المحتوى الرئيسي" : "Skip to main content"}
      </a>
      <Navbar />
      <main id="main-content" tabIndex={-1} className="flex-grow pt-20">
          {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
